import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { TokenService } from '../services/token.service';

export const alreadyLoggedOwnerGuard: CanActivateFn = () => {
  const authSvc = inject(AuthService);
  const tokenSvc = inject(TokenService);
  const router  = inject(Router);

  // เช็ค token ตรง (sync — อ่านจาก cookie ได้ทันที) เพื่อรองรับกรณี SSR/hydration
  // ที่ currentUser() อาจยังเป็น null ระหว่างรอ APP_INITIALIZER
  const hasToken = !!tokenSvc.getAccessToken();
  const hasUser  = !!authSvc.currentUser();

  if (hasToken || hasUser) {
    // ทุกกรณี → ไปเลือกร้านก่อน (รองรับ multi-store)
    // select-store จะเช็คเอง: มีร้าน/คำเชิญ → แสดง, ไม่มี → redirect ไป start
    return router.createUrlTree(['/owner/select-store']);
  }
  return true;
};
